/**
 * @param {Array<{ types?: string[], long_name?: string, short_name?: string }>|undefined|null} components
 * @returns {{ city: string, state: string, country: string }}
 */
export function parseGoogleAddressComponents(components) {
  if (!Array.isArray(components)) {
    return { city: '', state: '', country: '' }
  }

  let locality = ''
  let postalTown = ''
  let sublocality = ''
  let state = ''
  let country = ''

  for (const c of components) {
    const types = c.types || []
    if (types.includes('locality')) locality = c.long_name
    if (types.includes('postal_town')) postalTown = c.long_name
    if (types.includes('sublocality') || types.includes('sublocality_level_1')) {
      sublocality = c.long_name
    }
    if (types.includes('administrative_area_level_1')) state = c.short_name
    if (types.includes('country')) country = c.long_name
  }

  const city = locality || postalTown || sublocality || ''

  return { city, state, country }
}
